module.exports = __webpack_public_path__ + "static/media/back.40ef50d6.jpg";